'use strict';

class BaMobileOverlay extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.triggerElement = null;
    this.focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  }

  connectedCallback() {
    this.closeButton = this.querySelector('[data-close]');
    this.accordionTriggers = this.querySelectorAll('[data-accordion]');

    // Listen for the external hamburger trigger
    const hamburger = document.querySelector('[data-ba-mobile-trigger]');
    if (hamburger) {
      hamburger.addEventListener('click', () => this.open(hamburger));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    this.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(trigger);
      });
    });

    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        e.preventDefault();
        this.close();
      }

      if (e.key === 'Tab' && this.isOpen) {
        this.trapFocus(e);
      }
    });
  }

  open(triggerElement) {
    if (this.isOpen) return;

    this.isOpen = true;
    this.triggerElement = triggerElement || document.activeElement;

    this.classList.add('is-active');
    document.body.classList.add('ba-menu-open');

    // Stagger animations on L1 items
    const items = this.querySelectorAll('.ba-mobile-overlay__item');
    items.forEach((item, index) => {
      item.style.transitionDelay = (index * 50) + 'ms';
      requestAnimationFrame(() => {
        item.classList.add('is-visible');
      });
    });

    // Focus the first focusable element after transition
    requestAnimationFrame(() => {
      const firstFocusable = this.querySelector(this.focusableSelector);
      if (firstFocusable) {
        firstFocusable.focus();
      }
    });
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;

    // Remove stagger animation classes
    const items = this.querySelectorAll('.ba-mobile-overlay__item');
    items.forEach((item) => {
      item.classList.remove('is-visible');
      item.style.transitionDelay = '';
    });

    // Collapse all open accordions
    const expanded = this.querySelectorAll('.is-expanded');
    expanded.forEach((el) => el.classList.remove('is-expanded'));

    this.classList.remove('is-active');
    document.body.classList.remove('ba-menu-open');

    // Return focus to the element that opened the overlay
    if (this.triggerElement) {
      this.triggerElement.focus();
      this.triggerElement = null;
    }
  }

  toggleAccordion(trigger) {
    const parent = trigger.parentElement;
    const isExpanded = parent.classList.contains('is-expanded');

    // Close siblings at the same level
    const container = parent.parentElement;
    if (container) {
      const siblings = container.children;
      Array.from(siblings).forEach((sibling) => {
        if (sibling !== parent && sibling.classList.contains('is-expanded')) {
          sibling.classList.remove('is-expanded');
          const siblingTrigger = sibling.querySelector('[data-accordion]');
          if (siblingTrigger) {
            siblingTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }

    // Toggle the clicked item
    if (isExpanded) {
      parent.classList.remove('is-expanded');
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      parent.classList.add('is-expanded');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  trapFocus(event) {
    const focusableElements = Array.from(
      this.querySelectorAll(this.focusableSelector)
    ).filter((el) => el.offsetParent !== null); // Only visible elements

    if (focusableElements.length === 0) return;

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  }
}

customElements.define('ba-mobile-overlay', BaMobileOverlay);
